import { xml2js, xml2json } from 'xml-js';
import { ScorePartwise, XMLElementParser } from './elements';
const xml2jsOptions = {
    compact: false,
    nativeType: true,
    nativeTypeAttributes: true,
    ignoreDeclaration: true,
    ignoreInstruction: true,
    ignoreCdata: true,
    ignoreComment: true,
    ignoreDoctype: true
};
export class MusicXML extends XMLElementParser {
    get scorePartwise() {
        const node = this.node.elements?.find(e => e.name === 'score-partwise');
        return node ? new ScorePartwise(node) : undefined;
    }
    get sheets() {
        return this.scorePartwise?.parts.flatMap(p => p.sheets) ?? [];
    }
    static parse(xml) {
        const doc = xml2js(xml, xml2jsOptions);
        return new MusicXML(doc);
    }
    static xmlToJson(xml) {
        return xml2json(xml, { ...xml2jsOptions, spaces: 2 });
    }
}
//# sourceMappingURL=MusicXML.js.map